import { formatInTimeZone } from 'date-fns-tz'

const renderNumber = (num: number): string => (num < 10 ? `0${num}` : `${num}`)

export const renderDate = (
  dateStr: string,
  renderHour = false,
  separator = ' / ',
  reverse = false,
  calculateToServerTimezone = true
): string => {
  if (dateStr === undefined) {
    return ''
  }

  const serverTZ = process.env.REACT_APP_API_TIMEZONE
  const date = calculateToServerTimezone
    ? new Date(formatInTimeZone(new Date(dateStr), serverTZ ?? 'Europe/Warsaw', 'yyyy-MM-dd HH:mm'))
    : new Date(dateStr)

  if (date.toString() === 'Invalid Date') {
    return 'Bad Date Format'
  }

  const day = renderNumber(date.getDate())
  const month = renderNumber(date.getMonth() + 1)
  const year = renderNumber(date.getFullYear())
  const hour = renderNumber(date.getHours())
  const minutes = renderNumber(date.getMinutes())
  const seconds = renderNumber(date.getSeconds())

  if (reverse) {
    return `${year}${separator}${month}${separator}${day}${renderHour ? ` ${hour}:${minutes}:${seconds}` : ''}`
  }

  return `${day}${separator}${month}${separator}${year}${renderHour ? ` ${hour}:${minutes}:${seconds}` : ''}`
}
